angular.module('pitch.app')
.factory('LicencingFormModal', function(config, Modal) {
    return {
        open: function(params, data) {
            Modal.create(
                config.templateRoot + '/templates/synch/form-modal',
                params,
                data
            );
        }
    };
});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/LicencingFormModal.js